import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import axios from 'axios';

import { cart } from './cart';
import { favourites } from './favourites';
import { order } from './order';
import { payer } from './payer';
import { delivery } from './delivery';
import { recipient } from './recipient';
import { payment } from './payment';
import { informs } from './informs';
import { question } from './question';
import { set } from './set';
import { catalog } from './catalog';
import { purchases } from './purchases';

axios.defaults.headers.post['Content-Encoding'] = 'gzip';

Vue.use(Vuex);


export default new Vuex.Store({
    state: () => ({
        isAuth: false,
        name: null,
        email: null,
        phone: null,
    }),
    
    mutations: {
        setIsAuth: (state, payload) => {
            state.isAuth = payload.is_auth;
            state.name = payload.name;
            state.email = payload.email;
            state.phone = payload.phone;
        },
    },

    actions: {
        checkAuth: async ({ commit, dispatch }) => {
            let { data } = await axios.get('/ajax/auth');

            commit('setIsAuth', data);
            dispatch('informs/getInforms');
  
            if (data.is_auth) {               
                dispatch('favourites/getFavourites');
            }
        },
    },

    getters: {
        
    },

    modules: {
        favourites,
        cart,
        order,
        payer,
        delivery,
        recipient,
        payment,
        informs,
        question,
        set,
        catalog,
        purchases,
    }
});